import { createContext } from "react";
import { ISelectedRowsContext } from "./types";

export const SelectedRowsContext = createContext<ISelectedRowsContext>({
  filteredAcceptableWaitingRoomsCount: () => {
    throw new Error("filteredAcceptableWaitingRoomsCount is not implemented");
  },
  getAllRowsState: () => {
    throw new Error("getAllRowsState is not implemented");
  },
  getFilteredMassActionData: () => {
    throw new Error("getFilteredMassActionData is not implemented");
  },
  getMassActionData: () => {
    throw new Error("getMassActionData is not implemented");
  },
  getRowState: () => {
    throw new Error("getRowState is not implemented");
  },
  handleSelectAllRows: () => {
    throw new Error("handleSelectAllRows is not implemented");
  },
  handleSelectRow: () => {
    throw new Error("handleSelectRow is not implemented");
  },
  isSalaryDeductionSelected: () => {
    throw new Error("isSalaryDeductionSelected is not implemented");
  },
  isWaitingRoomSelected: () => {
    throw new Error("isWaitingRoomSelected is not implemented");
  },
  resetSelection: () => {
    throw new Error("resetSelection is not implemented");
  },
  selectedAcceptableSalaryDeductionsCount: 0,
  selectedAcceptableWaitingRoomsCount: 0,
  selectedSalaryDeductionsCount: 0,
  selectedCancellableWaitingRoomsCount: 0,
  selectSalaryDeduction: () => {
    throw new Error("selectSalaryDeduction is not implemented");
  },
  selectWaitingRoom: () => {
    throw new Error("selectWaitingRoom is not implemented");
  },
});
